import React from 'react';
import { Link } from 'react-router-dom';
import './Homework4.css';

const Homework7: React.FC = () => {
  return (
    <div className="homework4-container">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="content-wrapper">
        <Link to="/" className="back-button">
          ← Back to Hub
        </Link>

        <header className="homework4-header">
          <div className="badge">Homework 7</div>
          <h1>Advanced Image Restoration</h1>
          <p className="subtitle">Multi-step restoration: Motion Blur, Gaussian Noise & Periodic Noise Removal</p>
        </header>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📱</span>
            <h3>Median Filtering</h3>
            <p>Remove salt & pepper noise with adaptive median filtering (3x3 to 7x7)</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔄</span>
            <h3>Wiener Filtering</h3>
            <p>Adaptive noise reduction with automatic noise variance estimation</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎯</span>
            <h3>Motion Deblurring</h3>
            <p>Remove motion blur using Wiener deconvolution with PSF estimation</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌊</span>
            <h3>FFT Notch Filter</h3>
            <p>Eliminate periodic noise in frequency domain</p>
          </div>
        </div>

        <div className="questions-section">
          <h2>Restoration Tasks</h2>
          <div className="questions-grid">
            <Link
              to="/homework/7/main"
              className="question-card"
              style={{ '--card-color': '#10b981' } as React.CSSProperties}
            >
              <div className="question-number">🖼️</div>
              <h3>Image Restoration Interface</h3>
              <p>Upload degraded images and apply multi-step restoration pipeline with adjustable parameters.</p>
              <div className="card-arrow">→</div>
            </Link>
          </div>
        </div>

        <div className="info-box" style={{ marginTop: '40px' }}>
          <h4>About This Homework</h4>
          <p>
            This homework focuses on advanced image restoration techniques for severely degraded images.
            The restoration pipeline includes four steps: (1) Median filtering to remove impulsive noise,
            (2) Wiener filtering for adaptive noise suppression, (3) Motion deconvolution to remove blur,
            and (4) FFT-based notch filtering to eliminate periodic patterns. Each step builds upon the previous
            one to progressively restore the original image quality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Homework7;
